import { Controller } from '@hotwired/stimulus'

// Confirm controller for confirmation dialogs
// Usage: <button data-controller="confirm"
//                data-confirm-message-value="Вы уверены?"
//                data-action="confirm#confirm">Delete</button>
export default class extends Controller {
  static values = {
    message: { type: String, default: 'Вы уверены?' },
    title: { type: String, default: 'Подтверждение' }
  }

  confirm (event) {
    if (!window.confirm(this.messageValue)) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  // For custom modal confirmation (future implementation)
  showModal (event) {
    event.preventDefault()
    // TODO: Implement custom modal dialog
    // For now, fall back to browser confirm
    this.confirm(event)
  }
}
